/**
 * @generated SignedSource<<bc0de120ac807299260523b51721bdbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TaxonomyIcons_taxonomies",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Taxonomy",
      "kind": "LinkedField",
      "name": "taxonomy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "titleImageUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ResourceTreeTaxonomy",
  "abstractKey": null
};

node.hash = "d032cb80bada2d4c8d58f80fa5e3029f";

module.exports = node;
